import { Flex } from 'foundations-components/components/Flex';
import { splitLines } from '../../utils/stringUtils';
import { Text } from 'foundations-components/components/Text';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoteLines(props) {
  if (!props.note) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "0",
    children: splitLines(props.note).map((line, index) => /*#__PURE__*/_jsxs(_Fragment, {
      children: [index > 0 && /*#__PURE__*/_jsx(HR, {
        marginBlock: "100"
      }), /*#__PURE__*/_jsx(Text, {
        textWrap: "wrap",
        children: /*#__PURE__*/_jsx(SanitizedText, {
          body: line
        })
      }, index)]
    }))
  });
}